<section class="order-quick-access" [ngClass]="{ '!-left-424': !isShowingBox }">
  <!-- quick order form -->
  <div class="order-quick-access__form-container" id="order-quick-access-form">
    <form
      class="order-quick-access__form custom-scrollbar custom-scrollbar--gray"
      [formGroup]="orderForm">
      <!-- product title -->
      <pwj-input
        class="order-quick-access__input"
        icon="notes-1"
        iconPosition="left"
        [placeholder]="'home.enterYourProductTitle' | translate"
        [label]="'home.productTitle' | translate"
        formControlName="title"
        [messages]="{ required: 'requires.productTitle' }"></pwj-input>

      <!-- product category input -->
      <pwj-select-dropdown
        id="quick-order-select-input"
        class="order-quick-access__select"
        label="home.productCategory"
        placeholder="home.enterYourProductCategory"
        icon="grid-apps"
        iconPosition="left"
        variant="outlined"
        [options]="productCategories"
        formControlName="category_id"></pwj-select-dropdown>

      <!-- user email -->
      <pwj-input
        class="order-quick-access__input"
        icon="mail"
        iconPosition="left"
        [placeholder]="'home.enterYourEmail' | translate"
        [label]="'global.email' | translate"
        formControlName="email"
        type="email"></pwj-input>

      <!-- description input -->
      <pwj-input
        icon="stickynote"
        iconPosition="left"
        [isTextAreaMode]="true"
        placeholder="global.description"
        label="global.description"
        rows="3"
        formControlName="description"
        [messages]="{ required: 'requires.description' }">
      </pwj-input>

      <div class="order-quick-access__upload">
        <!-- upload file field -->
        <pwj-upload-files
          class="block w-full"
          label="uploader.image"
          multiple
          formControlName="file_ids"
          [wFull]="true"
          buttonsVariant="white"
          buttonsColor="info"></pwj-upload-files>
      </div>

      <!-- submit button -->
      @if (isUserLoggedIn) {
        <div class="order-quick-access__footer">
          <pwj-button
            class="submit-btn"
            variant="white"
            color="info"
            size="medium"
            icon="chevron-right"
            matomoClickCategory="Quick Order"
            matomoClickAction="Submit"
            matomoClickName="Side Menu"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            [ngClass]="{
              '!pointer-events-none !cursor-not-allowed': formIsSubmitting,
            }"
            (click)="!formIsSubmitting && submitOrder()"
            [disabled]="
              orderForm.invalid || isDisabledSubmitBtn || formIsSubmitting
            "
            >{{ 'global.send' | translate }}
          </pwj-button>
        </div>
      } @else {
        <div class="order-quick-access__footer">
          <pwj-register-button
            variant="white"
            color="info"
            size="medium"
            title="global.send"
            matomoClickCategory="Authentication"
            matomoClickAction="Login-Register"
            matomoClickName="Quick Order"></pwj-register-button>
        </div>
      }
    </form>
  </div>

  <!-- form toggle button -->
  <button
    class="order-quick-access__toggle-button"
    (click)="toggleOrderForm()"
    [ngClass]="{ '!-right-116  !bg-blue-600 !text-white-800': !isShowingBox }">
    <span class="order-quick-access__toggle-text">{{
      'orders.submitQuickOrder' | translate
    }}</span>

    @if (!isShowingBox) {
      <img
        class="order-quick-access__toggle-icon"
        ngSrc="assets/icons/order-icon.svg"
        width="26"
        height="26"
        alt="" />
    } @else {
      <i class="iconsax" icon-name="x"></i>
    }
  </button>
</section>
